// import axios from '../api/http'

const keys = {
  redirectURIKey: 'REDIRECT_URI',
  appIDKey: 'APP_ID',
  usernameKey: 'USERNAME',
  userIDKey: 'USER_ID',
  userIconKey: 'USER_ICON',
  createdAtKey: 'CREATED_AT_KEY',
  authKey: 'USER_AUTH',
}

// const verifyCodeImgUrl = 'http://127.0.0.1:8000/v1/img_verifier'
// cookie 写入地址
const cookieDomain = '.ddzzii.com'
// 叮咚智造首页
const homeDomain = 'http://www.ddzzii.com'
const defaultProfile = ''

export default {
  cookieDomain,
  homeDomain,
  keys,
  defaultProfile,
}
